// import { useState, useEffect, useCallback, useRef } from 'react';
// import axiosInstance from '../Datas/AxiosConfig';

// interface NotificationData {
//   success: boolean;
//   unread_count: number;
//   last_checked?: string;
//   new_bids?: any[];
//   new_requests?: any[];
//   job_requests?: any[];
// }

// interface UseNotificationsReturn {
//   unreadCount: number;
//   isLoading: boolean;
//   fetchNotifications: () => Promise<void>;
//   markAsRead: () => Promise<void>;
//   markRequestAsViewed: (requestId: number) => void;
//   getUnreadBidsPerRequest: () => Record<number, number>;
//   getUnreadJobRequests: () => Record<number, boolean>;
//   markJobRequestAsViewed: (requestId: number) => void;
// }

// // { requestId: ნანახი bid-ების რაოდენობა }
// type ViewedRequests = Record<number, number>;

// const getViewedRequestsKey = (userId: string, userType: string) => {
//   if (userType === 'craftsman') {
//     return `viewed_job_requests_craftsman_${userId}`;
//   }
//   return `viewed_job_requests_${userId}`;
// };

// const loadViewedRequests = (userType: string | null): ViewedRequests => {
//   if (!userType) return {};

//   try {
//     const userStr = localStorage.getItem('user');
//     if (!userStr) return {};

//     const user = JSON.parse(userStr);
//     const key = getViewedRequestsKey(user.external_Id, userType);
//     const stored = localStorage.getItem(key);

//     if (!stored) return {};

//     const parsed = JSON.parse(stored);

//     // ✅ ძველი ფორმატი (number[]) — გავასუფთაოთ და დავიწყოთ თავიდან.
//     // რატომ {} და არა მიგრაცია:
//     // - backend-ი last_checked timestamp-ით მართავს ძველ bid-ებს,
//     //   ამიტომ ძველი bid-ები ისედაც არ გამოჩნდება.
//     // - {} დაბრუნება = სუფთა სლეიტი, ახალი bid-ები სწორად დათვლება.
//     if (Array.isArray(parsed)) {
//       localStorage.removeItem(key);
//       return {};
//     }

//     return parsed as ViewedRequests;
//   } catch {
//     return {};
//   }
// };

// export const useNotifications = (userType: string | null): UseNotificationsReturn => {
//   const [unreadCount, setUnreadCount] = useState<number>(0);
//   const [isLoading, setIsLoading] = useState<boolean>(false);

//   // კლიენტისთვის: { requestId: წაუკითხავი bid-ების რაოდენობა }
//   const [unreadBidsPerRequest, setUnreadBidsPerRequest] = useState<Record<number, number>>({});

//   // ხელოსნისთვის: { requestId: true } — წაუკითხავი განცხადებები
//   const [unreadJobRequests, setUnreadJobRequests] = useState<Record<number, boolean>>({});

//   // { requestId: seenCount } — რამდენი bid ვნახეთ ამ განცხადებაზე
//   const [viewedRequests, setViewedRequests] = useState<ViewedRequests>(() =>
//     loadViewedRequests(userType)
//   );

//   const viewedRequestsRef = useRef<ViewedRequests>(viewedRequests);
//   const unreadBidsPerRequestRef = useRef<Record<number, number>>(unreadBidsPerRequest);
//   const unreadJobRequestsRef = useRef<Record<number, boolean>>(unreadJobRequests);

//   useEffect(() => { viewedRequestsRef.current = viewedRequests; }, [viewedRequests]);
//   useEffect(() => { unreadBidsPerRequestRef.current = unreadBidsPerRequest; }, [unreadBidsPerRequest]);
//   useEffect(() => { unreadJobRequestsRef.current = unreadJobRequests; }, [unreadJobRequests]);

//   // localStorage-ში შენახვა
//   useEffect(() => {
//     if (!userType) return;
//     try {
//       const userStr = localStorage.getItem('user');
//       if (!userStr) return;
//       const user = JSON.parse(userStr);
//       const key = getViewedRequestsKey(user.external_Id, userType);
//       localStorage.setItem(key, JSON.stringify(viewedRequests));
//     } catch (error) {
//       console.error('Error saving viewed requests:', error);
//     }
//   }, [viewedRequests, userType]);

//   const fetchNotifications = useCallback(async () => {
//     if (!userType || userType === 'unknown') return;

//     setIsLoading(true);

//     try {
//       const userStr = localStorage.getItem('user');
//       if (!userStr) { setIsLoading(false); return; }

//       const user = JSON.parse(userStr);
//       let endpoint = '';
//       const params: any = {};

//       // ========================================
//       // კლიენტი: განცხადებების მიხედვით bid count-ები
//       // ========================================
//       if (
//         userType === 'client' ||
//         userType === 'clientOfGoogle' ||
//         userType === 'clientOfFacebook'
//       ) {
//         endpoint = 'api/notifications/job-requests-unread/';

//         if (userType === 'clientOfFacebook' && user.external_Id) {
//           params.facebook_user_id = user.external_Id;
//         } else if (userType === 'clientOfGoogle' && user.external_Id) {
//           params.google_user_id = user.external_Id;
//         }

//       // ========================================
//       // ხელოსანი: ახალი განცხადებების სტატუსი
//       // ========================================
//       } else if (userType === 'craftsman') {
//         endpoint = 'api/notifications/new-requests/';

//       } else {
//         setIsLoading(false);
//         return;
//       }

//       const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

//       if (data.success) {

//         // ========================================
//         // კლიენტი: bid count-ების დამუშავება
//         // ========================================
//         if (data.job_requests) {
//           const unreadCounts: Record<number, number> = {};
//           let totalUnread = 0;

//           const currentViewed = viewedRequestsRef.current;

//           data.job_requests.forEach((item: any) => {
//             if (item.unread_bids_count > 0) {
//               // backend აბრუნებს last_checked-ის შემდეგ მოსულ bid-ებს.
//               // seenCount = ამ session-ში უკვე ნანახი bid-ები.
//               // სხვაობა = ახლა წასაკითხი.
//               const seenCount = currentViewed[item.id] ?? 0;
//               const actualUnread = item.unread_bids_count - seenCount;

//               if (actualUnread > 0) {
//                 unreadCounts[item.id] = actualUnread;
//                 totalUnread += actualUnread;
//               }
//             }
//           });

//           setUnreadBidsPerRequest(unreadCounts);
//           setUnreadCount(totalUnread);

//         // ========================================
//         // ხელოსანი: ახალი განცხადებების დამუშავება
//         // ========================================
//         } else if (data.new_requests && Array.isArray(data.new_requests)) {
//           const unreadRequests: Record<number, boolean> = {};
//           let totalUnread = 0;

//           const currentViewed = viewedRequestsRef.current;

//           data.new_requests.forEach((request: any) => {
//             if (!(request.id in currentViewed)) {
//               unreadRequests[request.id] = true;
//               totalUnread++;
//             }
//           });

//           setUnreadJobRequests(unreadRequests);
//           setUnreadCount(totalUnread);

//         // Fallback
//         } else if (data.unread_count !== undefined) {
//           setUnreadCount(data.unread_count);
//         } else {
//           setUnreadCount(0);
//         }

//       } else {
//         setUnreadCount(0);
//       }

//     } catch (error: any) {
//       console.error('Error fetching notifications:', error);
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         setUnreadCount(0);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   }, [userType]);

//   const markAsRead = useCallback(async () => {
//     if (!userType || userType === 'unknown') return;

//     setUnreadCount(0);
//     setUnreadBidsPerRequest({});
//     setUnreadJobRequests({});

//     try {
//       const userStr = localStorage.getItem('user');
//       if (!userStr) return;

//       const user = JSON.parse(userStr);
//       const payload: any = {};

//       if (
//         userType === 'client' ||
//         userType === 'clientOfGoogle' ||
//         userType === 'clientOfFacebook'
//       ) {
//         payload.type = 'bids';
//         if (userType === 'clientOfFacebook' && user.external_Id) {
//           payload.facebook_user_id = user.external_Id;
//         } else if (userType === 'clientOfGoogle' && user.external_Id) {
//           payload.google_user_id = user.external_Id;
//         }
//       } else if (userType === 'craftsman') {
//         payload.type = 'requests';
//       }

//       await axiosInstance.post('api/notifications/mark-read/', payload);

//       // ✅ Backend-ი განაახლებს last_checked timestamp-ს.
//       // viewed cache-ი ვასუფთავებთ — ახალი bid-ები თავიდან ითვლება 0-დან.
//       setViewedRequests({});

//     } catch (error) {
//       console.error('Error marking notifications as read:', error);
//     }
//   }, [userType]);

//   // ============================================
//   // კლიენტი: განცხადება ნანახად მონიშვნა
//   // ============================================
//   const markRequestAsViewed = useCallback((requestId: number) => {
//     const currentBidCount = unreadBidsPerRequestRef.current[requestId] || 0;

//     if (currentBidCount === 0) return;

//     // ✅ წინა seenCount + ახლა ნანახი = ჯამური ნანახი ამ session-ში
//     const previouslySeen = viewedRequestsRef.current[requestId] ?? 0;
//     const totalSeen = previouslySeen + currentBidCount;

//     const updatedViewed: ViewedRequests = {
//       ...viewedRequestsRef.current,
//       [requestId]: totalSeen,
//     };
//     viewedRequestsRef.current = updatedViewed;

//     try {
//       const userStr = localStorage.getItem('user');
//       if (userStr && userType) {
//         const user = JSON.parse(userStr);
//         const key = getViewedRequestsKey(user.external_Id, userType);
//         localStorage.setItem(key, JSON.stringify(updatedViewed));
//       }
//     } catch (error) {
//       console.error('Error saving to localStorage:', error);
//     }

//     setViewedRequests(updatedViewed);

//     setUnreadBidsPerRequest((prev) => {
//       const updated = { ...prev };
//       delete updated[requestId];
//       return updated;
//     });

//     setUnreadCount((currentCount) => Math.max(0, currentCount - currentBidCount));

//     // თუ ყველა განცხადება ნანახია — backend-ზეც მოვნიშნოთ
//     setTimeout(() => {
//       const remainingUnread = { ...unreadBidsPerRequestRef.current };
//       delete remainingUnread[requestId];
//       if (Object.keys(remainingUnread).length === 0) {
//         markAsRead();
//       }
//     }, 100);
//   }, [markAsRead, userType]);

//   // ============================================
//   // ხელოსანი: განცხადება ნანახად მონიშვნა
//   // ============================================
//   const markJobRequestAsViewed = useCallback((requestId: number) => {
//     if (viewedRequestsRef.current[requestId] !== undefined) return;

//     const updatedViewed: ViewedRequests = {
//       ...viewedRequestsRef.current,
//       [requestId]: 1,
//     };
//     viewedRequestsRef.current = updatedViewed;

//     try {
//       const userStr = localStorage.getItem('user');
//       if (userStr && userType) {
//         const user = JSON.parse(userStr);
//         const key = getViewedRequestsKey(user.external_Id, userType);
//         localStorage.setItem(key, JSON.stringify(updatedViewed));
//       }
//     } catch (error) {
//       console.error('Error saving to localStorage:', error);
//     }

//     setViewedRequests(updatedViewed);

//     setUnreadJobRequests((prev) => {
//       const updated = { ...prev };
//       delete updated[requestId];
//       return updated;
//     });

//     setUnreadCount((currentCount) => Math.max(0, currentCount - 1));

//     setTimeout(() => {
//       const remainingUnread = { ...unreadJobRequestsRef.current };
//       delete remainingUnread[requestId];
//       if (Object.keys(remainingUnread).length === 0) {
//         markAsRead();
//       }
//     }, 100);
//   }, [markAsRead, userType]);

//   const getUnreadBidsPerRequest = useCallback(() => unreadBidsPerRequest, [unreadBidsPerRequest]);
//   const getUnreadJobRequests = useCallback(() => unreadJobRequests, [unreadJobRequests]);

//   // ✅ Page Visibility API — tab არაქტიურია მაშინ API-ს არ ვიძახებთ
//   useEffect(() => {
//     fetchNotifications();

//     const interval = setInterval(() => {
//       if (!document.hidden) {
//         fetchNotifications();
//       }
//     }, 30000);

//     const handleVisibilityChange = () => {
//       if (!document.hidden) {
//         fetchNotifications();
//       }
//     };
//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
//       clearInterval(interval);
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
//   }, [fetchNotifications]);

//   return {
//     unreadCount,
//     isLoading,
//     fetchNotifications,
//     markAsRead,
//     markRequestAsViewed,
//     getUnreadBidsPerRequest,
//     getUnreadJobRequests,
//     markJobRequestAsViewed,
//   };
// };










///////////////////////////ოპტიმიზირებული ვარიანტი
import { useState, useEffect, useCallback, useRef } from 'react';
import axiosInstance from '../Datas/AxiosConfig';

interface NotificationData {
  success: boolean;
  unread_count: number;
  last_checked?: string;
  new_bids?: any[];
  new_requests?: any[];
  job_requests?: any[];
}

interface UseNotificationsReturn {
  unreadCount: number;
  isLoading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: () => Promise<void>;
  markRequestAsViewed: (requestId: number) => void;
  getUnreadBidsPerRequest: () => Record<number, number>;
  getUnreadJobRequests: () => Record<number, boolean>;
  markJobRequestAsViewed: (requestId: number) => void;
}

type ViewedRequests = Record<number, number>;

const getViewedRequestsKey = (userId: string, userType: string) => {
  if (userType === 'craftsman') {
    return `viewed_job_requests_craftsman_${userId}`;
  }
  return `viewed_job_requests_${userId}`;
};

const loadViewedRequests = (userType: string | null): ViewedRequests => {
  if (!userType) return {};

  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return {};

    const user = JSON.parse(userStr);
    const key = getViewedRequestsKey(user.external_Id, userType);
    const stored = localStorage.getItem(key);

    if (!stored) return {};

    const parsed = JSON.parse(stored);

    if (Array.isArray(parsed)) {
      localStorage.removeItem(key);
      return {};
    }

    return parsed as ViewedRequests;
  } catch {
    return {};
  }
};

export const useNotifications = (userType: string | null): UseNotificationsReturn => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [unreadBidsPerRequest, setUnreadBidsPerRequest] = useState<Record<number, number>>({});
  const [unreadJobRequests, setUnreadJobRequests] = useState<Record<number, boolean>>({});
  const [viewedRequests, setViewedRequests] = useState<ViewedRequests>(() =>
    loadViewedRequests(userType)
  );

  // ✅ userType ref-ში — dependency array-დან ამოღება შესაძლებელია
  const userTypeRef = useRef(userType);
  const viewedRequestsRef = useRef<ViewedRequests>(viewedRequests);
  const unreadBidsPerRequestRef = useRef<Record<number, number>>(unreadBidsPerRequest);
  const unreadJobRequestsRef = useRef<Record<number, boolean>>(unreadJobRequests);

  // ✅ ref-ები განახლდება state-თან სინქრონულად
  useEffect(() => { userTypeRef.current = userType; }, [userType]);
  useEffect(() => { viewedRequestsRef.current = viewedRequests; }, [viewedRequests]);
  useEffect(() => { unreadBidsPerRequestRef.current = unreadBidsPerRequest; }, [unreadBidsPerRequest]);
  useEffect(() => { unreadJobRequestsRef.current = unreadJobRequests; }, [unreadJobRequests]);

  // localStorage-ში შენახვა
  useEffect(() => {
    if (!userTypeRef.current) return;
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;
      const user = JSON.parse(userStr);
      const key = getViewedRequestsKey(user.external_Id, userTypeRef.current);
      localStorage.setItem(key, JSON.stringify(viewedRequests));
    } catch (error) {
      console.error('Error saving viewed requests:', error);
    }
  }, [viewedRequests]);

  // ✅ dependency array ცარიელია — userTypeRef.current იყენებს
  const fetchNotifications = useCallback(async () => {
    const currentUserType = userTypeRef.current;
    if (!currentUserType || currentUserType === 'unknown') return;

    // console.log('🔔 fetchNotifications called, userType:', currentUserType);

    setIsLoading(true);

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) { setIsLoading(false); return; }

      const user = JSON.parse(userStr);
      let endpoint = '';
      const params: any = {};

      if (
        currentUserType === 'client' ||
        currentUserType === 'clientOfGoogle' ||
        currentUserType === 'clientOfFacebook'
      ) {
        endpoint = 'api/notifications/job-requests-unread/';

        if (currentUserType === 'clientOfFacebook' && user.external_Id) {
          params.facebook_user_id = user.external_Id;
        } else if (currentUserType === 'clientOfGoogle' && user.external_Id) {
          params.google_user_id = user.external_Id;
        }

      } else if (currentUserType === 'craftsman') {
        endpoint = 'api/notifications/new-requests/';

      } else {
        setIsLoading(false);
        return;
      }

      const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

      if (data.success) {

        if (data.job_requests) {
          const unreadCounts: Record<number, number> = {};
          let totalUnread = 0;

          const currentViewed = viewedRequestsRef.current;

          data.job_requests.forEach((item: any) => {
            if (item.unread_bids_count > 0) {
              const seenCount = currentViewed[item.id] ?? 0;
              const actualUnread = item.unread_bids_count - seenCount;

              if (actualUnread > 0) {
                unreadCounts[item.id] = actualUnread;
                totalUnread += actualUnread;
              }
            }
          });

          setUnreadBidsPerRequest(unreadCounts);
          setUnreadCount(totalUnread);

        } else if (data.new_requests && Array.isArray(data.new_requests)) {
          const unreadRequests: Record<number, boolean> = {};
          let totalUnread = 0;

          const currentViewed = viewedRequestsRef.current;

          data.new_requests.forEach((request: any) => {
            if (!(request.id in currentViewed)) {
              unreadRequests[request.id] = true;
              totalUnread++;
            }
          });

          setUnreadJobRequests(unreadRequests);
          setUnreadCount(totalUnread);

        } else if (data.unread_count !== undefined) {
          setUnreadCount(data.unread_count);
        } else {
          setUnreadCount(0);
        }

      } else {
        setUnreadCount(0);
      }

    } catch (error: any) {
      console.error('Error fetching notifications:', error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setUnreadCount(0);
      }
    } finally {
      setIsLoading(false);
    }
  }, []); // ✅ ცარიელი — userTypeRef.current იყენებს

  // ✅ dependency array ცარიელია — userTypeRef.current იყენებს
  const markAsRead = useCallback(async () => {
    const currentUserType = userTypeRef.current;
    if (!currentUserType || currentUserType === 'unknown') return;

    setUnreadCount(0);
    setUnreadBidsPerRequest({});
    setUnreadJobRequests({});

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;

      const user = JSON.parse(userStr);
      const payload: any = {};

      if (
        currentUserType === 'client' ||
        currentUserType === 'clientOfGoogle' ||
        currentUserType === 'clientOfFacebook'
      ) {
        payload.type = 'bids';
        if (currentUserType === 'clientOfFacebook' && user.external_Id) {
          payload.facebook_user_id = user.external_Id;
        } else if (currentUserType === 'clientOfGoogle' && user.external_Id) {
          payload.google_user_id = user.external_Id;
        }
      } else if (currentUserType === 'craftsman') {
        payload.type = 'requests';
      }

      await axiosInstance.post('api/notifications/mark-read/', payload);
      setViewedRequests({});

    } catch (error) {
      console.error('Error marking notifications as read:', error);
    }
  }, []); // ✅ ცარიელი

  const markRequestAsViewed = useCallback((requestId: number) => {
    const currentBidCount = unreadBidsPerRequestRef.current[requestId] || 0;
    if (currentBidCount === 0) return;

    const previouslySeen = viewedRequestsRef.current[requestId] ?? 0;
    const totalSeen = previouslySeen + currentBidCount;

    const updatedViewed: ViewedRequests = {
      ...viewedRequestsRef.current,
      [requestId]: totalSeen,
    };
    viewedRequestsRef.current = updatedViewed;

    try {
      const userStr = localStorage.getItem('user');
      if (userStr && userTypeRef.current) {
        const user = JSON.parse(userStr);
        const key = getViewedRequestsKey(user.external_Id, userTypeRef.current);
        localStorage.setItem(key, JSON.stringify(updatedViewed));
      }
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }

    setViewedRequests(updatedViewed);
    setUnreadBidsPerRequest((prev) => {
      const updated = { ...prev };
      delete updated[requestId];
      return updated;
    });
    setUnreadCount((currentCount) => Math.max(0, currentCount - currentBidCount));

    setTimeout(() => {
      const remainingUnread = { ...unreadBidsPerRequestRef.current };
      delete remainingUnread[requestId];
      if (Object.keys(remainingUnread).length === 0) {
        markAsRead();
      }
    }, 100);
  }, [markAsRead]); // ✅ userType ამოღებულია

  const markJobRequestAsViewed = useCallback((requestId: number) => {
    if (viewedRequestsRef.current[requestId] !== undefined) return;

    const updatedViewed: ViewedRequests = {
      ...viewedRequestsRef.current,
      [requestId]: 1,
    };
    viewedRequestsRef.current = updatedViewed;

    try {
      const userStr = localStorage.getItem('user');
      if (userStr && userTypeRef.current) {
        const user = JSON.parse(userStr);
        const key = getViewedRequestsKey(user.external_Id, userTypeRef.current);
        localStorage.setItem(key, JSON.stringify(updatedViewed));
      }
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }

    setViewedRequests(updatedViewed);
    setUnreadJobRequests((prev) => {
      const updated = { ...prev };
      delete updated[requestId];
      return updated;
    });
    setUnreadCount((currentCount) => Math.max(0, currentCount - 1));

    setTimeout(() => {
      const remainingUnread = { ...unreadJobRequestsRef.current };
      delete remainingUnread[requestId];
      if (Object.keys(remainingUnread).length === 0) {
        markAsRead();
      }
    }, 100);
  }, [markAsRead]); // ✅ userType ამოღებულია

  const getUnreadBidsPerRequest = useCallback(() => unreadBidsPerRequestRef.current, []);
  const getUnreadJobRequests = useCallback(() => unreadJobRequestsRef.current, []);

  useEffect(() => {
    fetchNotifications();

    const interval = setInterval(() => {
      if (!document.hidden) {
        fetchNotifications();
      }
    }, 30000);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        fetchNotifications();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [fetchNotifications]); // ✅ fetchNotifications აღარ იცვლება — ერთხელ გაეშვება

  return {
    unreadCount,
    isLoading,
    fetchNotifications,
    markAsRead,
    markRequestAsViewed,
    getUnreadBidsPerRequest,
    getUnreadJobRequests,
    markJobRequestAsViewed,
  };
};